__turbopack_context__.v({
  "scrollbar": "scroll-area-module__HOcxUa__scrollbar",
});
